import { h } from "preact";
import { useContext, useEffect, useMemo, useRef, useState } from "preact/hooks";
import TextInput from "../../../../../common/TextInput";
import { checkEmail } from "../../../../../../tools";

export default function OwnerStepSell({ formContext, onNext }) {
  const { formData } = useContext(formContext);
  const { address, accountNumber } = formData;

  const phoneInputRef = useRef(null);
  const [isRemoveAddressActive, setIsRemoveAddressActive] = useState(false);

  const [ownerData, setOwnerData] = useState({
    lastName: formData.lastName || "",
    firstName: formData.firstName || "",
    middleName: formData.middleName || "",
    phone: formData.phone || "",
    removeAddress: formData.removeAddress || false,
  });

  const [errors, setErrors] = useState({});

  const validateForm = () => {
    let newErrors = {};
    if (!ownerData.lastName) newErrors.lastName = "Введите фамилию";
    if (!ownerData.firstName) newErrors.firstName = "Введите имя";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { id, value } = e.target;
    if (id === "email" && value && !checkEmail(value)) {
      setErrors((prev) => ({ ...prev, email: "Введите корректный email" }));
    } else {
      setOwnerData((prev) => ({ ...prev, [id]: value }));
    }
    if (errors[id]) setErrors((prev) => ({ ...prev, [id]: "" }));
  };

  const handleNext = () => {
    if (validateForm()) {
      ym(51133895, "reachGoal", "flat_sell");
      onNext(ownerData);
    }
  };

  const isFormValid = useMemo(() => {
    return (
      ownerData.lastName &&
      ownerData.firstName &&
      !Object.values(errors).some((error) => error)
    );
  }, [ownerData, errors]);

  useEffect(() => {
    if (phoneInputRef.current) {
      window
        .Inputmask({
          mask: "+7 (999) 999 9999",
          clearIncomplete: true,
          oncomplete: function (e) {
            setOwnerData((prev) => ({ ...prev, phone: e.target.value }));
          },
          onincomplete: function () {
            setOwnerData((prev) => ({ ...prev, phone: "" }));
          },
        })
        .mask(phoneInputRef.current);
    }
  }, []);

  return (
    <div className="owner-step">
      <div className="owner-info">
        <p>{address}</p>
        <span>ЛС {accountNumber}</span>
      </div>
      <h1>Введите данные нового собственника жилого помещения</h1>
      <div className="form">
        <div className="form__body">
          {["lastName", "firstName", "middleName"].map((field) => (
            <div className="form__fieldset" style={{ paddingTop: "0" }}>
              <TextInput
                key={field}
                name={
                  field === "lastName"
                    ? "Фамилия"
                    : field === "firstName"
                    ? "Имя"
                    : "Отчество (при наличии)"
                }
                isRequired={field !== "middleName"}
                inputProps={{
                  value: ownerData[field],
                  onChange: handleChange,
                  id: field,
                }}
                errors={errors[field]}
              />
            </div>
          ))}
          <div className="form__fieldset">
            <div className="form__item form__item_horizontal">
              <TextInput
                name="Контактный номер телефона нового собственника"
                inputProps={{
                  value: ownerData.phone,
                  onChange: handleChange,
                  id: "phone",
                  ref: phoneInputRef,
                }}
                errors={errors.phone}
              />
            </div>
          </div>

          <div className="form__fieldset">
            <label class="form-field__title" for="phone">
              Удалить адрес из моего личного кабинета?
            </label>
            <div className="form__item owner-actions">
              <button
                className={`button-secondary button-secondary_border-gray ${
                  ownerData.removeAddress && isRemoveAddressActive
                    ? "active"
                    : ""
                }`}
                onClick={() => {
                  setOwnerData((prev) => ({ ...prev, removeAddress: true }));
                  setIsRemoveAddressActive(true);
                }}
              >
                Да
              </button>
              <button
                className={`button-secondary button-secondary_border-gray ${
                  !ownerData.removeAddress && isRemoveAddressActive
                    ? "active"
                    : ""
                }`}
                onClick={() => {
                  setOwnerData((prev) => ({ ...prev, removeAddress: false }));
                  setIsRemoveAddressActive(true);
                }}
              >
                Нет
              </button>
            </div>
          </div>
        </div>

        {Object.values(errors).map((error) => (
          <div className="form__error-text">{error}</div>
        ))}

        <button
          className="button-primary button-primary_pdv_lg form__submit-btn"
          onClick={handleNext}
          disabled={!isFormValid}
        >
          Сохранить изменения
        </button>
      </div>
    </div>
  );
}
